'use client';
/* Built In Imports */

/* External Imports */
import { Box, Skeleton } from '@chakra-ui/react';
import { Suspense, useEffect, useState } from 'react';
/* Internal Imports */
/* Components */
import RenderSections from '@app-ila/Common/RenderSections';
import config from '@config';
import { nanoid } from 'nanoid';
import { usePathname } from 'next/navigation';
/**
 * Renders the MainUi component
 *
 * @param {Object} pageData - content from api
 * @returns {ReactElement} MainUi component
 */
const MainUi = ({ pageData }) => {
  const [isLoader, setIsLoader] = useState(false);
  const pathname = usePathname();
  let mode;
  if (
    pathname === '/sadhguru-academy/privacy-policy' ||
    pathname === '/sadhguru-academy/terms-of-use'
  ) {
    mode = 'light';
  } else {
    mode = 'blue';
  }
  useEffect(() => {
    if (document != undefined) {
      const script = document.createElement('script');
      script.src = `${config.ILAINLINEFORM}`;
      script.async = true;
      document.body.appendChild(script);
      setIsLoader(true);
    }
    setTimeout(function () {
      setIsLoader(false);
    }, 0);
    return () => { };
  }, []);
  return (
    <Suspense fallback={<Skeleton />}>
      <Box as="section" className="container" p="0">
        {pageData?.body?.map(section => {
          return (
            <RenderSections
              pageData={pageData}
              section={section}
              key={nanoid(4)}
              mode={mode}
            />
          );
        })}
      </Box>
    </Suspense>
  );
};
export default MainUi;
